import {AfterViewInit, Component, Inject, OnDestroy, OnInit, ViewChild} from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef, MatDialogTitle, MatDialogContent, MatDialogActions, MatDialogClose } from '@angular/material/dialog';
import {MessageLogsDatasource} from './message-logs.datasource';
import {MatPaginator} from '@angular/material/paginator';
import { MatSort, MatSortHeader } from '@angular/material/sort';
import {merge} from 'rxjs';
import {tap} from 'rxjs/operators';
import {AdvancedMessagingService} from '../../api/services/advanced-messaging.service';
import {ExportFieldModel} from '../../api/models/export-field-model';
import * as _ from 'lodash';
import {MatExportDialogComponent} from '../../dialogs/mat-export/mat-export-dialog.component';
import {CallLogsFilterModel} from '../../api/models/call-logs-filter-model';
import {MatAlertDialogComponent} from '../../dialogs/mat-alert/mat-alert-dialog.component';
import {MessageLogsFilterModel} from '../../api/models/message-logs-filter-model';
import { CdkScrollable } from '@angular/cdk/scrolling';
import { FlexModule } from '@angular/flex-layout';
import { NgIf, AsyncPipe } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { MatTable, MatColumnDef, MatHeaderCellDef, MatHeaderCell, MatCellDef, MatCell, MatHeaderRowDef, MatHeaderRow, MatRowDef, MatRow } from '@angular/material/table';
import { MatButton } from '@angular/material/button';
import { Angular2PromiseButtonModule } from 'angular2-promise-buttons';
import { PhoneNumberPipe } from '../../core/pipes/phone-number.pipe';
import { DateTimePipe } from '../../core/pipes/date-time.pipe';

export interface MessageLogsDialogData {
  type: string;
  threadKey: string;
}

@Component({
    selector: 'app-message-logs-dialog',
    template: `
    <h2 mat-dialog-title>Message Logs</h2>
    <mat-dialog-content class="mat-typography" style="height: calc(100% - 95px); max-height: 100%">
      <div fxLayout="column" fxFlexFill>
        <div fxLayout="column" fxFlexFill class="spinner-container" *ngIf="dataSource.loading$ | async">
          <mat-spinner></mat-spinner>
        </div>
        <div fxFlex="auto" fxFlexFill class="table-container">
          <mat-table [dataSource]="dataSource" multiTemplateDataRows class="regular-table"
                     matSort matSortActive="createdOn" matSortDirection="desc" matSortDisableClear>
            <ng-container matColumnDef="eventType">
              <mat-header-cell *matHeaderCellDef mat-sort-header="eventType">Type</mat-header-cell>
              <mat-cell *matCellDef="let row">
                <span class="mobile-label">Type:</span>
                <span>
                  {{row.eventType}}
                </span>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="createdOn">
              <mat-header-cell *matHeaderCellDef mat-sort-header="createdOn">Date</mat-header-cell>
              <mat-cell *matCellDef="let row">
                <span class="mobile-label">Date:</span>
                <span>
                  {{row.createdOn | dateTime: 'M/dd/yyyy hh:mm a'}}
                </span>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="tnFrom">
              <mat-header-cell *matHeaderCellDef mat-sort-header="tnFrom">From</mat-header-cell>
              <mat-cell *matCellDef="let row">
                <span class="mobile-label">From:</span>
                <span>
                  {{row.tnFrom | phoneNumber}}
                </span>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="tnTo">
              <mat-header-cell *matHeaderCellDef mat-sort-header="tnTo">To</mat-header-cell>
              <mat-cell *matCellDef="let row">
                <span class="mobile-label">To:</span>
                <span>
                  {{row.tnTo | phoneNumber}}
                </span>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="contactName">
              <mat-header-cell *matHeaderCellDef mat-sort-header="contactName">Contact Name</mat-header-cell>
              <mat-cell *matCellDef="let row">
                <span class="mobile-label">Contact Name:</span>
                <span>
                  {{row.contactName}}
                </span>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="contactCompanyName">
              <mat-header-cell *matHeaderCellDef mat-sort-header="contactCompanyName">Contact Company Name</mat-header-cell>
              <mat-cell *matCellDef="let row">
                <span class="mobile-label">Contact Company Name:</span>
                <span>
                  {{row.contactCompanyName}}
                </span>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="contactEmail">
              <mat-header-cell *matHeaderCellDef mat-sort-header="contactEmail">Contact Email</mat-header-cell>
              <mat-cell *matCellDef="let row">
                <span class="mobile-label">Contact Email:</span>
                <span>
                  {{row.contactEmail}}
                </span>
              </mat-cell>
            </ng-container>

            <ng-container matColumnDef="deliveryDescription">
              <mat-header-cell *matHeaderCellDef mat-sort-header="deliveryDescription">Status</mat-header-cell>
              <mat-cell *matCellDef="let row">
                <span class="mobile-label">Status:</span>
                <span>
                  <span>{{row.state}}</span>
                  <span *ngIf="additionalFilter.type === 'failed'"> - {{row.deliveryDescription}}</span>
                </span>
                {{ row.status }}
              </mat-cell>
            </ng-container>

            <!-- Header and Row Declarations -->
            <mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></mat-header-row>
            <mat-row *matRowDef="let row; columns: displayedColumns" class="call-logs-row"></mat-row>
          </mat-table>
        </div>
        <mat-paginator fxFlex="initial" [length]="dataSource.dataCount$ | async" [pageSize]="100"></mat-paginator>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions align="end">
      <button mat-button [mat-dialog-close]="false">Close</button>
      <button mat-flat-button color="primary" (click)="onProcessConfirm()" [promiseBtn]="onConfirm">Export</button>
    </mat-dialog-actions>
  `,
    styles: [
        '.mat-column-eventType { max-width: 80px;min-width: 80px;}',
        '.mat-column-createdOn { max-width: 200px;min-width: 200px;}',
        '.mat-column-tnFrom { max-width: 150px;min-width: 150px;}',
        '.mat-column-tnTo { max-width: 150px;min-width: 150px;}',
    ],
    standalone: true,
    imports: [
        MatDialogTitle,
        CdkScrollable,
        MatDialogContent,
        FlexModule,
        NgIf,
        MatProgressSpinner,
        MatTable,
        MatSort,
        MatColumnDef,
        MatHeaderCellDef,
        MatHeaderCell,
        MatSortHeader,
        MatCellDef,
        MatCell,
        MatHeaderRowDef,
        MatHeaderRow,
        MatRowDef,
        MatRow,
        MatPaginator,
        MatDialogActions,
        MatButton,
        MatDialogClose,
        Angular2PromiseButtonModule,
        AsyncPipe,
        PhoneNumberPipe,
        DateTimePipe,
    ],
})
export class MessageLogsDialogComponent implements OnInit, OnDestroy, AfterViewInit {

  displayedColumns: string[] = ['eventType', 'createdOn', 'tnFrom', 'tnTo', 'contactName', 'contactCompanyName', 'contactEmail', 'deliveryDescription'];
  dataSource: MessageLogsDatasource;
  additionalFilter: any = {};
  @ViewChild(MatPaginator) paginator: MatPaginator;
  @ViewChild(MatSort) sort: MatSort;

  public exportColumnsDefinition: ExportFieldModel[] = [
    {id: _.uniqueId('id_'), field: 'eventType', title: 'Event', width: 20},
    {id: _.uniqueId('id_'), field: 'createdOn', title: 'Date', width: 20, style: {numFmt: 'DD/MM/YYYY hh:mm:ss AM/PM'}},
    {id: _.uniqueId('id_'), field: 'tnFrom', title: 'Number From', width: 10},
    {id: _.uniqueId('id_'), field: 'tnTo', title: 'Number To', width: 10},
    {id: _.uniqueId('id_'), field: 'contactName', title: 'Contact Name', width: 10},
    {id: _.uniqueId('id_'), field: 'contactCompanyName', title: 'Contact Company Name', width: 10},
    {id: _.uniqueId('id_'), field: 'contactEmail', title: 'Contact Email', width: 10},
    {id: _.uniqueId('id_'), field: 'deliveryDescription', title: 'Delivery Status', width: 10},
  ];

  constructor(private advancedMessagingService: AdvancedMessagingService,
              public dialog: MatDialog,
              public dialogRef: MatDialogRef<MessageLogsDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: MessageLogsDialogData,
  ) {

  }

  onConfirm: Promise<void>;

  ngOnInit() {
    this.additionalFilter.threadKey = this.data.threadKey;
    this.additionalFilter.type = this.data.type;
    this.dataSource = new MessageLogsDatasource(this.advancedMessagingService);
  }

  ngOnDestroy() {
  }

  ngAfterViewInit(): void {
    /*this.filterChangeEvent?.subscribe(() => {
      this.paginator.pageIndex = 0;
    });*/

    this.sort.sortChange.subscribe(() => this.paginator.pageIndex = 0);

    merge(this.sort.sortChange, this.paginator.page)
      .pipe(
        tap(() => this.loadMessageLogs())
      )
      .subscribe();

    this.loadMessageLogs();
  }

  loadMessageLogs() {
    console.log('filter changed');
    this.dataSource.queryData({
      skip: this.paginator.pageIndex * this.paginator.pageSize,
      limit: this.paginator.pageSize,
      sort: [{field: this.sort.active, direction: this.sort.direction ? this.sort.direction.toUpperCase() : undefined}],
      threadKey: this.additionalFilter.threadKey,
      type: this.additionalFilter.type,
      phoneNumbers: this.additionalFilter.phoneNumbers,
      startDate: this.additionalFilter.startDate,
      endDate: this.additionalFilter.endDate,
      user: undefined
    });
  }

  showMessageLogs($event: { type: string; threadKey: string }) {
    console.log($event);
  }

  async onExportClick() {
    console.log('exportLogs');
    const exportColumns = this.exportColumnsDefinition.map((x: any) => {
      return {
        text: x.title,
        value: x.id,
        field: x.field,
        hidden: x.hidden,
        id: x.id
      };
    });

    const selectedExportColumns = this.exportColumnsDefinition.map((item) => item.id);

    const dialogRef = this.dialog.open(MatExportDialogComponent, {
      width: '500px',
      data: {
        availableColumns: exportColumns,
        selectedColumns: selectedExportColumns
      }
    });

    dialogRef.afterClosed().subscribe(async (result: any[]) => {
      if (result) {
        await this.onExport(result);
      }
    });
  }

  async onExport(selectedExportColumns: string[]) {
    const exColumns: ExportFieldModel[] = this.exportColumnsDefinition
      .filter((x) => {
        return selectedExportColumns.indexOf(x.id) > -1;
      });

    const filter: MessageLogsFilterModel = Object.assign({}, this.additionalFilter || {});

    const exportResponse = await this.advancedMessagingService.proMessagingReportsExportLogs({
      body: {
        filter: filter,
        exportFields: exColumns
      }
    }).toPromise();
    console.log('export response', exportResponse);

    this.dialog.open(MatAlertDialogComponent, {
      width: '500px',
      data: {
        title: 'Export Information',
        actionTitle: 'Got It',
        text: `Export started successfully. Process can take up to 30 minutes. When export file will be ready you will get email notification.`
      }
    });
  }

  async onProcessConfirm() {
    this.onConfirm = this.onExportClick();

    await this.dialogRef.close();
  }
}
